import React from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { Close, Search } from '@mui/icons-material';

// Params for JobSearchBar component
interface JobSearchBarParams {
  query: string,
  updateQuery: (query: string) => void,
  placeholder: string,
  // number of jobs matching the current query
  matchCount: number,
  // total number of jobs available on the page
  totalCount: number,
}

/**
 * Search bar which filters the jobs shown in a datagrid.
 * @param query the current search query
 * @param updateQuery updates the search query
 * @param placeholder placeholder text describing what can be searched
 * @param matchCount number of jobs matching the current query
 * @param totalCount total number of jobs on the page
 * @constructor
 */
export const JobSearchBar = function ({
  query, updateQuery, placeholder, matchCount, totalCount,
}: JobSearchBarParams) {
  return (
    <div className="flex flex-row items-center gap-4">
      <TextField
        value={query}
        onChange={(event) => updateQuery(event.target.value)}
        placeholder={placeholder}
        size="small"
        className="bg-white"
        sx={{ width: 420 }}
        InputProps={{
          inputProps: { 'aria-label': 'Search jobs' },
          startAdornment: (
            <InputAdornment position="start">
              <Search className="text-gray-500" />
            </InputAdornment>
          ),
          // only show the clear button once the user has typed something
          endAdornment: query ? (
            <InputAdornment position="end">
              <IconButton aria-label="Clear search" size="small" onClick={() => updateQuery('')}>
                <Close fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
      />
      {/* summary of how many jobs the current query matched */}
      {!!query && (
        <div className="text-sm text-gray-600">
          {`${matchCount} of ${totalCount} ${totalCount === 1 ? 'job' : 'jobs'}`}
        </div>
      )}
    </div>
  );
};
